import React from "react" 
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent, parseContentGroup } from "./utils"
import { formatSequentialString } from "lib/utils/policies"

export default function PolicyBlock({ policy }:{ policy:any }){
  const wrapperStyling = useRenderStyling("flex flex-col mt-1 mb-1", "styleObj")
  const textNormal = useRenderStyling("text-sm", "styleObj")
  const textBold = useRenderStyling("text-sm font-bold", "styleObj")
    
  return (
    <div {...wrapperStyling}>
      <span {...textBold}>{policy.type.charAt(0).toUpperCase()}{policy.type.substring(1)} policy:</span>
      {policy.text.length > 0 && ( <span {...textNormal}>{policy.text}</span> )}
      {policy.url > 0 && ( <span {...textNormal}>{policy.url}</span> )}
    </div>
  )
}